export default {
  getRoomDistribution(state) {
    return state.roomDistribution;
  },
  getRoomDistributionPayload(state) {
    return state.roomDistributionPayload;
  },
};
